import moment from 'moment';
import titleCase from 'title-case';
import { formatAMPM, isMultiDateRange } from './format';

export const validateTYTDisplay = (targetDate: string) => {
  if (!targetDate) {
    return false;
  }
  const currentDate = `${moment().format('YYYY-MM-DD')}`;
  const startWindow = `${moment(targetDate).format('YYYY-MM-DD')}`;
  const endWindow = `${moment(targetDate)
    .add(1, 'day')
    .format('YYYY-MM-DD')}`;
  return moment(currentDate).isBetween(startWindow, endWindow, null, '[]');
};

export const validateTYTInTransitEnable = (targetDate: string) => {
  if (!targetDate) {
    return false;
  }
  const currentDate = `${moment().format('YYYY-MM-DD')}`;
  return moment(currentDate).isAfter(
    moment(targetDate)
      .subtract(1, 'day')
      .format('YYYY-MM-DD')
  );
};

export const getTimeZone = () => {
  let zone = '';
  try {
    const ua = window.navigator.userAgent;
    const isIE = /MSIE|Trident/.test(ua);
    if (isIE) {
      zone = /\((.*)\)/
        .exec(new Date().toString())[1]
        .match(/\b([A-Z])/g)
        .join('');
    } else {
      zone = new Date()
        .toLocaleTimeString('en-us', { timeZoneName: 'short' })
        .split(' ')
        .slice(2);
    }
  } catch (e) {
    return zone;
  }
  return zone;
};

export const formatReservationWindow = (
  timePayload: Object,
  isMultDate: boolean,
  serviceType: string
) => {
  const messageArray = [];
  const { startDateTime, endDateTime } = timePayload;
  if (!(startDateTime || endDateTime)) {
    return '';
  }
  if (serviceType) {
    messageArray.push(`${titleCase(serviceType)}, `);
  }
  if (isMultDate) {
    messageArray.push(
      formatAMPM(moment(startDateTime).format('dddd, MMMM D, h:mm a - '))
    );
    messageArray.push(
      formatAMPM(
        `${moment(endDateTime).format('dddd, MMMM D, h:mm a')} ${getTimeZone()}`
      )
    );
    return messageArray;
  }
  messageArray.push(
    formatAMPM(
      `${moment(startDateTime).format('h:mm a -')} ${moment(endDateTime).format(
        'h:mm a '
      )}`
    )
  );
  messageArray.push(`${getTimeZone()}, `);
  messageArray.push(moment(startDateTime).format('dddd, MMMM D'));
  return messageArray;
};

export const formatReservationWindowOrderGroups = (bodfsDeliveries: Object) => {
  const {
    reservationWindowStartTime = '',
    reservationWindowEndTime = '',
  } = bodfsDeliveries;

  const timePayload = {
    startDateTime: reservationWindowStartTime,
    endDateTime: reservationWindowEndTime,
  };
  const isMultDate = isMultiDateRange(bodfsDeliveries);

  return formatReservationWindow(timePayload, isMultDate);
};

export const formatProcessingMinorBlock = (
  date: string,
  isMultDate: boolean
) => {
  const messageArray = [];
  if (!date) {
    messageArray.push('----');
    return messageArray;
  }
  if (isMultDate) {
    messageArray.push(moment(date).format('MMM. D, '));
  }
  messageArray.push(formatAMPM(moment(date).format('h:mm a')));
  return messageArray;
};

export const formatEstimatedArrival = (
  timePayload: Object,
  isMultDate: boolean
) => {
  const messageArray = [];
  const { startDateTime, endDateTime } = timePayload;
  if (!(startDateTime || endDateTime)) {
    return '';
  }
  const formatString = isMultDate ? 'MMM. D, h:mm a' : 'h:mm a';

  messageArray.push(
    formatAMPM(moment(startDateTime).format(`${formatString} - `))
  );
  messageArray.push(formatAMPM(moment(endDateTime).format(formatString)));
  return messageArray;
};

export const formatDeliveredText = (date: string) =>
  formatAMPM(moment(date).format('MMM. D, h:mm a'));
